import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=82832f4c&scoped=true&"
import script from "./StockReport.vue?vue&type=script&lang=ts&"
export * from "./StockReport.vue?vue&type=script&lang=ts&"
import style0 from "./StockReport.vue?vue&type=style&index=0&id=82832f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82832f4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
